/**
 * Client helpers for handoff batch checkbox selection.
 */

export function reasonLabel(reason) {
  if (reason === "pending") return "Pending handoff";
  if (reason === "done") return "Completed";
  if (reason === "deleted") return "Deleted";
  return null;
}

/** Flatten candidate tree into a map of post_id → node. */
export function indexHandoffTree(tree, map = new Map()) {
  if (!tree) return map;
  map.set(tree.post_id, tree);
  for (const child of tree.children || []) {
    indexHandoffTree(child, map);
  }
  return map;
}

/** Collect descendant post ids (not including self). */
export function collectDescendantIds(node, out = []) {
  for (const child of node?.children || []) {
    out.push(child.post_id);
    collectDescendantIds(child, out);
  }
  return out;
}

/**
 * Build initial checked set from candidates API tree.
 * Only eligible nodes (including root when eligible).
 */
export function initialCheckedIds(tree) {
  const checked = new Set();
  const walk = (node) => {
    if (!node) return;
    if (node.eligible) checked.add(node.post_id);
    for (const child of node.children || []) {
      walk(child);
    }
  };
  walk(tree);
  return checked;
}

/**
 * Toggle a node: uncheck parent → uncheck descendants;
 * check parent → check eligible descendants.
 */
export function toggleHandoffSelection(tree, checked, postId, nextChecked) {
  const byId = indexHandoffTree(tree);
  const node = byId.get(postId);
  if (!node || !node.eligible) return new Set(checked);
  // Root cannot be unchecked
  const rootId = tree?.post_id;
  if (postId === rootId && !nextChecked) return new Set(checked);

  const next = new Set(checked);
  if (nextChecked) {
    next.add(postId);
    for (const id of collectDescendantIds(node)) {
      const child = byId.get(id);
      if (child?.eligible) next.add(id);
    }
  } else {
    next.delete(postId);
    for (const id of collectDescendantIds(node)) {
      next.delete(id);
    }
  }
  return next;
}

export function countSelected(checked) {
  return checked?.size || 0;
}
